import ProductListFilterComponent from './components/ProductListFilterComponent';

window.addEventListener('vue-init', () => {
    mountVueComponent('product-list-filter', ProductListFilterComponent);
})

if (typeof(mountVueComponent) == 'function') {
    mountVueComponent('product-list-filter', ProductListFilterComponent);
}




// WEBPACK FOOTER //
// ./resources/assets/site/js/product-list-filter.js